import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 8a1 1 0 0 0 2 0V3.3a.3.3 0 0 1 .3-.3H8a1 1 0 1 0 0-2H2a1 1 0 0 0-1 1zM23 8a1 1 0 0 1-2 0V3.3a.3.3 0 0 0-.3-.3H16a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1zM1 16a1 1 0 0 1 2 0v4.7a.3.3 0 0 0 .3.3H8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zM23 16a1 1 0 0 0-2 0v4.7a.3.3 0 0 1-.3.3H16a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": ".5",
      d: "M15.08 9.746a.583.583 0 1 0-.826-.825L12 11.175 9.746 8.921a.583.583 0 0 0-.825.825L11.175 12l-2.254 2.254a.583.583 0 1 0 .825.825L12 12.825l2.254 2.254a.583.583 0 1 0 .825-.825L12.825 12z"
    }, null, -1)
  ]))]))
}
export default { render: render }